import { render, staticRenderFns } from "./ZoomClient.vue?vue&type=template&id=137d6470&scoped=true&"
import script from "./ZoomClient.vue?vue&type=script&lang=js&"
export * from "./ZoomClient.vue?vue&type=script&lang=js&"
import style0 from "./ZoomClient.vue?vue&type=style&index=0&id=137d6470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d6470",
  null
  
)

export default component.exports